import React from 'react';
import '../../styles/ViewModifiedRailChains.css';

// Компонент для отображения измененных цепочек рельсов

const ViewModifiedRailChains = ({ data, t }) => {
  const getLabel = (key) => {
    return t?.[key] || key;
  };

  // Хелпер для форматирования значений
  const formatValue = (value, isTrack = false) => {
    if (isTrack) {
      return value ? `${value?.substring(0, 20)}...` : '-';
    }
    return value !== null && value !== undefined && value !== '' ? value : '-';
  };

  // Функция для отрисовки строк таблицы
  const renderRows = (fields) => {
    return Object.keys(fields)
      .filter(
        (key) => key !== 'meta' && !(key === 'railChainName' && (fields[key].new === '' || fields[key].new === null))
      )
      .map((key) => {
        const { old, new: newValue } = fields[key];
        const isTrack = key === 'track';

        return (
          <tr key={key} className="table__row">
            <td className="table__cell">{getLabel(key)}</td>
            <td className="table__cell">{formatValue(old, isTrack)}</td>
            <td className="table__cell">
              {isTrack ? t?.trackChangedNote || 'данные об изменении трека в таблице ниже' : formatValue(newValue)}
            </td>
          </tr>
        );
      });
  };

  // Функция для отрисовки секций таблицы
  const renderSections = () => {
    return Object.keys(data)
      .filter((id) => Object.keys(data[id]).length > 0)
      .map((id) => {
        const railChainNameMeta = data[id]?.meta?.railChainName;
        const railChainName = data[id]?.railChainName;

        return (
          <React.Fragment key={id}>
            <tr>
              <td colSpan="3" className="table__section-id">
                {id}
                {railChainNameMeta &&
                  (railChainName?.new ? `, ${railChainName?.old} → ${railChainName?.new}` : `, ${railChainNameMeta}`)}
              </td>
            </tr>
            {renderRows(data[id])}
          </React.Fragment>
        );
      });
  };

  return (
    <table className="table">
      <thead>
        <tr>
          <th className="table__header">{t?.fieldName || 'Название поля'}</th>
          <th className="table__header">{t?.oldValue || 'Старое значение'}</th>
          <th className="table__header">{t?.newValue || 'Новое значение'}</th>
        </tr>
      </thead>
      <tbody>{renderSections()}</tbody>
    </table>
  );
};

export default ViewModifiedRailChains;
